import React from "react"
import { graphql } from "gatsby"

import Partner from "components/partner"

const PartnerPage = (props) => {
  const {
    data: { partner },
  } = props

  return <Partner partner={partner} />
}

export default PartnerPage

export const query = graphql`
  query ($id: String) {
    partner(id: { eq: $id }) {
      ... on Partner {
        active
        articles {
          ... on Article {
            authors {
              name
              url
            }
            id
            category
            partner {
              name
              logo
              url
            }
            previewImage
            titles {
              body
              site
            }
            url
          }
        }
        description
        facebookId
        facebookPage
        id
        instagram
        logo
        name
        pinterest
        previewLogo
        twitter
        url
      }
    }
  }
`
